<template>
  <span :class="[type]" :style="{ color }">
    <span v-if="hasAmount" class="symbol" :style="{ fontSize: symbolSize }">{{ symbolByLocale }}</span>
    <span class="amount" :style="{ fontSize: amountSize }">{{ formattedAmount }}</span>
  </span>
</template>

<script>
  export default {
    name: 'mgAmount',
    props: {
      amount: {
        type: [String, Number],
        default: 0,
      },
      symbolSize: {
        type: String,
        default: '18px',
      },
      amountSize: {
        type: String,
        default: '18px',
      },
      color: String,
      type: {
        type: String,
        default: '',
      },
    },
    computed: {
      /**
       * 是否需要展示金额，false 时金额和货币符号都不渲染
       * 注意：prop 声明了 default: 0，Vue 会先把 undefined 替换成 0，
       * 因此本组件内的 amount 不会是 undefined，「undefined 显示为 0」由 default 保证；
       * 这里的 undefined 判断仅用于兜底绕过 default 直接赋值的极端场景。
       */
      hasAmount() {
        const { amount } = this
        return amount !== null && amount !== undefined && amount !== ''
      },
      // 判断语言
      symbolByLocale() {
        const locale = this.$MGUI?.i18n.locale
        // 暂时除人民币外全部显示美元
        if (locale === 'zh-CN') {
          return '￥'
        } else {
          return '$'
        }
      },
      formattedAmount() {
        // 后台可能存在该字段为 null 的情况（如商品未维护零售价），
        // 直接调用 toString 会抛错，导致 Vue 渲染失败并复用上一次的 vnode，页面显示上一个价格
        if (!this.hasAmount) return ''
        return String(this.amount).replace(/\d+/, (n) => {
          return n.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  span {
    &.primary {
      color: $mg--amount-color-primary;
    }
  }
</style>
